module.exports = __webpack_public_path__ + "static/media/winterbilanz.434b8524.jpg";